import styled from 'styled-components'
import type { FunctionComponent, ReactNode } from 'react'
import { formatNoResultsMessage } from './utils'
import Paragraph from '../Paragraph/Paragraph'

const StyledList = styled.ul`
  list-style: square;
  margin-bottom: 1.5rem;
`

const StyledH3 = styled.h3`
  font-size: 1.25rem;
  margin: 0 0 0.5rem;
`

const ListItem = styled.li`
  margin-left: 1.125rem;
  margin-bottom: 0;
  &::marker {
    width: 0.5rem;
  }
  p {
    margin: 0;
  }
`

const StyledListItem: FunctionComponent<{ children: ReactNode }> = ({ children }) => (
  <ListItem>
    <Paragraph small>{children}</Paragraph>
  </ListItem>
)

export interface NoSearchResultsProps {
  query: string
  label?: string
}

const NoSearchResults: FunctionComponent<NoSearchResultsProps> = ({ query, label = '' }) => (
  <>
    <Paragraph small data-testid="noSearchResults">
      {formatNoResultsMessage(query, label)}
    </Paragraph>
    <br />
    <StyledH3>Zoeksuggesties</StyledH3>
    <StyledList>
      <StyledListItem>Maak de zoekcriteria eventueel minder specifiek.</StyledListItem>
    </StyledList>
  </>
)

export { StyledList, StyledListItem }

export default NoSearchResults
